import { render, staticRenderFns } from "./SvgFoodCategory.vue?vue&type=template&id=12e586ca&scoped=true"
import script from "./SvgFoodCategory.vue?vue&type=script&lang=js"
export * from "./SvgFoodCategory.vue?vue&type=script&lang=js"
import style0 from "./SvgFoodCategory.vue?vue&type=style&index=0&id=12e586ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e586ca",
  null
  
)

export default component.exports